module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-LightItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-LightItalic-webfont.eot
// module id = 690
// module chunks = 0